<template>
  <Modal
      ref="modal"
      v-model="config.dis"
      width="600"
      :mask="false"
      draggable
      scrollable
      title="提示"
      :closable="false"
      :mask-closable="false"
    
    >
    <div>
      <VForm 
        ref="form"
        v-model="params"
        :fields="fields"
        />
      <p style="text-align:right">已完成付款的共计{{records_select_len}}人，未完成的{{un_records_select_len}}人</p>
      <p v-show="records_select_len===0&&config.dis" style="text-align:right;color:red">
        至少选中一个才能提交数据
      </p>
    </div>
    <div slot="footer">
        <Button
          @click="config.dis = false"
        >
          取消
        </Button>
        <Button
          :disabled="records_select_len===0"
          type="primary"
          :loading="saving"
          @click="submit"
        >
          确定
        </Button>
      </div>
  </Modal>
</template>
<script>
import VForm from '@/vuetify_custom/v-form'
import { arrObjToHash } from '../../../libs/util'
export default {
  components: {
    VForm
  },
  props: {
      // :info="page_info"
      //   :records_select="records_select_hash"
      info: {
        type: Object,
      },
      records_select: {
        type: Object,
      },
      value: {
        type: Boolean
      },
      topic: {
         type: Object,
      }
  },
  data() {
            this.fields=[
                    {
                        label: '付款时间',
                        key:'paid_at',
                        type:'date_picker_v1',
                        showButton: false,
                        cols: 12,
                        allowedDates() {
                          return true
                        },
                        rules:[val => {
                          return !!val || '付款时间必选'
                        }],
                      },
                ]
    return {
      config: {
         dis: this.value,
      },
      params: {
        paid_at: ''
      },
      saving: false
    }
  },
  watch: {
  'config.dis'(val) {
      this.$emit('input',val)
    },
    value(val) {
      this.config.dis = val
    }
  },
  computed: {
    records_select_len() {
      let arr =this.config.dis&& Object.keys(this.records_select).filter(key=>!!this.records_select[key]) || []
      return arr.length
    },
    un_records_select_len() {
      return Number(this.info&&this.info.total || 0)-this.records_select_len
    }
  },
  methods: {
    setZindex() {
      const child = this.$refs.modal.$el.getElementsByTagName('div')[0]
      child.style = "z-index:200"
    },
    show() {
     // this.dis = true
    },
    submit() {
      //   console.log('测啊蜂蜜水补充v吗，x b v j')
        if(!this.$refs.form.validate()) {
          return 
        }
        this.saving = true
        let arr = []
        Object.keys(this.records_select).forEach(key=>{
          if(this.records_select[key]) {
              arr.push(key)
          }
        })
      this.$http.post(Util.api.update_informal_wage_topic_status, {
        id:this.topic.id,
        status: 'finished',
        record_ids: arr,
        paid_at: this.params.paid_at
      }).then((data) => {
        this.$Message.success('数据提交成功')
      this.config.dis = false
       this.$emit('success')
      }).finally(() => {
        this.setZindex()
        this.saving = false
      })
    }
  }
}
</script>
